﻿import {useMemo} from 'react';
import {SupplierActivitySummaryVo} from "../../../types/supplier/SupplierActivitySummaryVo";
import {supplierActivitySummaryReportEndpoints} from "../../../requests/api-endpoints";
import {SortDirType} from "../../../types/common/SortDirType";
import {useGetRequestAutoAbortPaginated} from "../../request/useGetRequestAutoAbortPaginated";

interface UseSupplierActivitySummaries {
  page?: string;
  rowsPerPage?: string;
  date?: string;
  sort: string;
  sortDir: SortDirType;
  locationId: string;
}

/**
 * Hook for reactively grabbing data from the SupplierActivitySummaries endpoint.
 * Automatically aborts previous requests and separates pagination info and the data
 **/
const useSupplierActivitySummaries = ({ page, rowsPerPage, date, sort, sortDir, locationId }: UseSupplierActivitySummaries) => {
  const queryParams = useMemo(() => ({
    date: date,
    page: page,
    size: rowsPerPage,
    sortBy: sort,
    sortDir: sortDir,
    locationId: locationId
  }), [date, locationId, page, rowsPerPage, sort, sortDir]);

  const {
    responseContent: activitySummaries,
    pageInfo,
    isLoading,
    error,
  } = useGetRequestAutoAbortPaginated<SupplierActivitySummaryVo[]>({ requestUrl: supplierActivitySummaryReportEndpoints.report, queryParams})

  return {
    activitySummaries,
    pageInfo,
    isLoading,
    error
  }
}

export { useSupplierActivitySummaries };
